import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';

document.addEventListener('alpine:init', () => {
  Alpine.data('projectsSlider', () => ({
    currentSlide: 1,
    init() {
      const slider = new Splide(this.$refs.projectsSlider, {
        pagination: false,
        type: 'fade',
        lazyLoad: 'nearby',
        preloadPages: 1,
      });
      slider.on('move', (newIndex) => (this.currentSlide = newIndex + 1));
      slider.mount();
    },
  }));
});
